import { render, staticRenderFns } from "./ProductTax.vue?vue&type=template&id=1dedc330"
import script from "./ProductTax.vue?vue&type=script&lang=js"
export * from "./ProductTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports